<div *transloco="let t">
	<ng-container>
		<div class="px-12 flex flex-row">
			<div class="pt-6 pb-3 title">
				{{ t('userProfile.updateMail') }}
			</div>
		</div>
		<div class=" px-12 flex flex-wrap flex-row {{ isMobile() ? 'w-full' : 'w-1/3' }}">
			<mat-form-field [ngClass]="'w-full'" appearance="fill">
				<mat-label>{{ t('userProfile.mailAddress') }}</mat-label>
				<input (keyup)="checkMailValidator()" [formControl]="mailAddressFC" matInput />
				<mat-error>{{ errorMsg() }}</mat-error>
			</mat-form-field>
		</div>
	</ng-container>
</div>
